import React from 'react';
import { Button } from 'devextreme-react/button';

import HXUserFilters from '../../../custom-components/hx-user-filters/HXUserFilters'
import ShuttlesAdminFleetDataGrid from './sub-components/ShuttlesAdminFleetDataGrid'
import HxPopupExportExcel from '../../../custom-components/hx-popup-excel-export/HxPopupExportExcel';
import PopupShuttlesAdminFleetUserSettings from './sub-components/PopupShuttlesAdminFleetUserSettings'

import './ShuttlesAdminFleet.scss';


class ShuttlesAdminFleet extends React.Component {
    constructor(props) {
        super(props);

        this.popupExportExcelInstance = null;
        this.popupShuttlesAdminFleetUserSettingsInstance = null;

        // filters
        this.loadedUserFilterValue = [];
    }

    popupExportExcel_OnInitialized = (instance) => {
        this.popupExportExcelInstance = instance;
    }

    popupExportExcel_OnSave = async (fileName) => {
        if (fileName) {
            await this.refDataGrid.exportToExcel(fileName);
        }
    }

    popupShuttlesAdminFleetUserSettings_OnInitialized = (instance) => {
        this.popupShuttlesAdminFleetUserSettingsInstance = instance;
    }

    popupShuttlesAdminFleetUserSettings_OnUpdate = (elementId, value) => {
        this.refDataGrid.applyUserSettings(elementId, value)
    }

    exportFleet = async () => {
        this.popupExportExcelInstance.show();
    }

    buttonUserSettings_OnClick = (e) => {
        this.popupShuttlesAdminFleetUserSettingsInstance.show();
    }

    // GRID
    grid_OnInitialized = (instance) => {
        this.dataGridInstance = instance;
        this.refUserFilters.setDataGridInstance(instance);
    }

    // USERFILTER
    userFilterLoaded = async (filterState) => {
        // display loadpanel
        this.dataGridInstance.beginCustomLoading("Loading...");

        this.dataGridInstance.beginUpdate();

        if (filterState.filterValue !== undefined) {
            this.dataGridInstance.option('filterValue', JSON.parse(filterState.filterValue));
            this.loadedUserFilterValue = this.dataGridInstance.option('filterValue');
        } else {
            this.loadedUserFilterValue = [];
        }

        this.dataGridInstance.endUpdate();

        // hide loadpanel
        this.dataGridInstance.endCustomLoading();
    }

    clearUserFilter = () => {
        this.dataGridInstance.clearFilter();
    }

    userFilterError = (error) => {
        //this.setErrorHeader(error);
    }

    render() {
        return (
            <React.Fragment>
                <div className='shuttles-admin-fleet-main-div'>
                    <div className='shuttles-admin-fleet-content-block'>
                        <div id='toolBarFleet' className='hx-toolbar-main-div'>
                            <div className='hx-toolbar-left'>
                                <span>
                                    <Button
                                        icon="xlsxfile"
                                        stylingMode='outlined'
                                        text="Fleet"
                                        onClick={this.exportFleet} />
                                </span>
                            </div>
                            <div className='hx-toolbar-right'>
                                <span>
                                    <HXUserFilters
                                        ref={ref => (this.refUserFilters = ref)}
                                        onUserFilterLoaded={this.userFilterLoaded}
                                        onClearFilter={this.clearUserFilter}
                                        onError={this.userFilterError}
                                        filterTypeName='fleet'
                                    />
                                </span>
                                <span>
                                    <Button
                                        icon='preferences'
                                        stylingMode='text'
                                        text=''
                                        onClick={this.buttonUserSettings_OnClick}
                                    />
                                </span>
                            </div>
                        </div>
                        <div className='shuttles-admin-fleet-grid-card'>
                            <ShuttlesAdminFleetDataGrid
                                ref={ref => this.refDataGrid = ref}
                                onInitialized={this.grid_OnInitialized}
                            />
                        </div>
                    </div>
                </div>

                <HxPopupExportExcel
                    defaultName='Fleet'
                    onInitialized={this.popupExportExcel_OnInitialized}
                    onSave={this.popupExportExcel_OnSave}
                />

                <PopupShuttlesAdminFleetUserSettings
                    onInitialized={this.popupShuttlesAdminFleetUserSettings_OnInitialized}
                    onUpdate={this.popupShuttlesAdminFleetUserSettings_OnUpdate}
                />
            </React.Fragment>
        );
    }
}

export default ShuttlesAdminFleet
